<template>
  <div>
    <b-tag v-if="isAdministrator" type="is-info">Todas as unidades</b-tag>
    <b-button v-else size="is-small" type="is-primary" outlined :disabled="disabled" @click="open">
      {{ user.pending ? 'Indisponível' : 'Unidades' }}
    </b-button>

    <b-modal :active.sync="active" has-modal-card>
      <section class="hero is-fullheight">
        <div class="hero-body">
          <div class="container has-text-centered">
            <div class="column">
              <h3 class="title has-text-white">
                Unidades de {{ user.name || user.userEmail || user.invitationEmail }}
              </h3>
              <div class="box">
                <b-loading :active="loading" :is-full-page="false" />
                <b-notification v-if="error" type="is-danger" has-icon :closable="false">
                  Não foi possível carregar as unidades deste usuário. Tente novamente.
                </b-notification>
                <b-table class="units-table" :data="activeUnits" :mobile-cards="true">
                  <b-table-column field="code" label="Código" v-slot="props">
                    {{ props.row.code }}
                  </b-table-column>
                  <b-table-column field="name" label="Nome" v-slot="props">
                    <span class="unit-name">{{ props.row.name }}</span>
                  </b-table-column>
                  <b-table-column centered label="Permitir" v-slot="props">
                    <b-checkbox
                      v-model="selectedIds"
                      :native-value="props.row.id"
                      :disabled="saving || loading"
                    />
                  </b-table-column>
                  <template #empty>
                    <div class="has-text-centered has-text-grey">
                      Nenhuma unidade ativa encontrada.
                    </div>
                  </template>
                </b-table>
                <p class="help mt-4">
                  Apenas unidades ativas podem ser associadas a um novo acesso.
                </p>
                <hr />
                <div class="footer-buttons">
                  <button class="button closed-button" @click.stop.prevent="active = false">
                    Fechar
                  </button>
                  <button
                    class="button is-success"
                    :class="{ ' is-loading': saving }"
                    :disabled="loading || !!error"
                    @click.stop.prevent="save"
                  >
                    Salvar
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </b-modal>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex';

export default {
  name: 'BuyerUserUnits',
  props: {
    user: { type: Object, required: true },
    buyerId: { type: Number, required: true },
    canManage: { type: Boolean, default: false },
  },
  data() {
    return {
      active: false,
      selectedIds: [],
      loading: false,
      saving: false,
      error: null,
    };
  },
  computed: {
    ...mapGetters('purchasingUnits', {
      units: 'purchasingUnits',
      linkedIds: 'userPurchasingUnitIds',
    }),
    disabled() {
      return !this.canManage || this.user.pending || this.isAdministrator;
    },
    isAdministrator() {
      return this.user.accessMode === 'ALL' || this.user.function === 'ADMINISTRADOR';
    },
    activeUnits() {
      return this.units.filter(unit => unit.status === 'ACTIVE');
    },
  },
  methods: {
    ...mapActions('purchasingUnits', [
      'fetchAllPurchasingUnits',
      'fetchUserPurchasingUnits',
      'saveUserPurchasingUnits',
    ]),
    async open() {
      if (this.disabled) return;
      this.active = true;
      this.loading = true;
      this.error = null;
      try {
        await this.fetchAllPurchasingUnits({ buyerId: this.buyerId });
        await this.fetchUserPurchasingUnits({
          companyId: this.user.companyId,
          companyUserId: this.user.companyUserId,
        });
        this.selectedIds = [...this.linkedIds];
      } catch (error) {
        this.error = error;
      } finally {
        this.loading = false;
      }
    },
    async save() {
      this.saving = true;
      try {
        await this.saveUserPurchasingUnits({
          companyId: this.user.companyId,
          companyUserId: this.user.companyUserId,
          purchasingUnitIds: this.selectedIds,
        });
        this.$alerta('Unidades do usuário atualizadas', 'is-success');
        this.active = false;
      } catch (error) {
        const message = error?.response?.data?.details?.message || error?.response?.data?.message;
        this.$alerta(message || 'Erro ao atualizar unidades do usuário', 'is-danger');
      } finally {
        this.saving = false;
      }
    },
  },
};
</script>

<style lang="scss">
.closed-button {
  margin-right: 0.4rem;
}

.footer-buttons {
  justify-content: center;
  width: 100%;
}

.units-table .table-wrapper.has-mobile-cards tr td {
  border-bottom: 1px solid #dbdbdb;
}

.units-table .table-wrapper.has-mobile-cards tr th {
  border-bottom: 2px solid #dbdbdb;
}

.unit-name {
  display: block;
  overflow-wrap: anywhere;
  text-align: left;
}
</style>
